import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\">\n    <path d=\"M13 5.94506H7.05503V0H5.94506V5.94506H0V7.05503H5.94506V13.0003H7.05503V7.05503H13V5.94506Z\" fill=\"white\" fill-opacity=\"0.95\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol